import { render, staticRenderFns } from "./SetWinners.vue?vue&type=template&id=4321169c&scoped=true"
import script from "./SetWinners.vue?vue&type=script&lang=js"
export * from "./SetWinners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4321169c",
  null
  
)

export default component.exports